import { API_SOCKET_URL } from '@common/env'

const apiSocketUrl = API_SOCKET_URL

export default {
  apiSocketUrl
}
